import { Button, Form, Input, Row, Select, Col, DatePicker } from "antd";
const { RangePicker } = DatePicker;
import React, { Component } from "react";
import "../SearchForm/SearchForm.css";
import FormItem from "antd/lib/form/FormItem";
import { Constant } from "../../config/index";
import moment from "moment";
import { MAPKEY_FORM_VALUE } from "./service";

const { Option } = Select;

class SearchRawLog extends Component {
  handleOnSubmit = (e) => {
    e.preventDefault();

    const self = this;
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      const payload = {};

      payload["collection"] = values["col"];

      const dates = values["range_date"];
      payload["start_date"] = moment(dates[0]).format("YYYY-MM-DD");
      payload["end_date"] = moment(dates[1]).format("YYYY-MM-DD");
      payload["b"] = true;

      // map column to exact field based on collection.
      if (!!values["member_id"]) {
        payload["a"] = values["member_id"];
      }

      if (!!values["country"]) {
        const countryKey = MAPKEY_FORM_VALUE[payload["collection"]]["country"];
        payload[countryKey] = values["country"];
      }

      if (!!values["msisdn"]) {
        payload["c"] = values["msisdn"];
      }

      if (!!values["sender"]) {
        const senderKey = MAPKEY_FORM_VALUE[payload["collection"]]["sender"];
        payload[senderKey] = values["sender"];
      }

      if (!!values["smid"]) {
        const smidKey = MAPKEY_FORM_VALUE[payload["collection"]]["smid"];
        payload[smidKey] = values["smid"];
      }

      if (!!values["gateway_smid"]) {
        const gatewaySmidKey =
          MAPKEY_FORM_VALUE[payload["collection"]]["gateway_smid"];
        payload[gatewaySmidKey] = values["gateway_smid"];
      }

      if (!!values["status"] && values["status"] !== "ALL") {
        const statusKey = MAPKEY_FORM_VALUE[payload["collection"]]["status"];
        payload[statusKey] = values["status"];
      }

      if (!!values["gateway"] && values["gateway"] !== "ALL") {
        const gatewayKey = MAPKEY_FORM_VALUE[payload["collection"]]["gateway"];
        payload[gatewayKey] = values["gateway"];
      }

      self.props.cb(payload);
    });
  };

  handleOnChangeCollection = (col) => {
    // hook to parent component
    this.props.onChangeCol(col);
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const { reset } = this.props;

    return (
      <Form
        className="search-raw-frm"
        onSubmit={this.handleOnSubmit}
        colon={false}
      >
        <Row gutter={16}>
          <Col span={3}>
            <Form.Item label="Service">
              {getFieldDecorator("col", {
                rules: [{ required: true }],
              })(
                <Select
                  placeholder="SMS Type"
                  style={{ width: "120px" }}
                  onChange={this.handleOnChangeCollection}
                >
                  <Option key="sl_type-1" value={Constant.TABLE_SMS_LOGS.API}>
                    API
                  </Option>
                  <Option
                    key="sl_type-2"
                    value={Constant.TABLE_SMS_LOGS.CAMPAIGN}
                  >
                    Campaign
                  </Option>
                  <Option key="sl_type-3" value={Constant.TABLE_SMS_LOGS.SMPP}>
                    Smpp
                  </Option>
                  <Option
                    key="sl_type-4"
                    value={Constant.TABLE_SMS_LOGS.VIBER_CAM}
                  >
                    Viber-Campaign
                  </Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="Range Sent Date">
              {getFieldDecorator("range_date", {
                rules: [{ required: true }],
                initialValue: [moment().subtract(1, "M"), moment()],
              })(
                <RangePicker
                  disabledDate={(_date) =>
                    _date > moment().add(1, "h") ||
                    _date < moment().subtract(3, "M")
                  }
                  separator="-"
                />
              )}
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item label="Member ID">
              {getFieldDecorator("member_id")(<Input />)}
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item label="Country">
              {getFieldDecorator("country")(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={2}>
            <Form.Item label="Phone">
              {getFieldDecorator("msisdn")(<Input />)}
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item label="Sender ID">
              {getFieldDecorator("sender")(<Input />)}
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item label="Gateway">
              {getFieldDecorator("gateway", { initialValue: "ALL" })(
                <Select>
                  <Option value={"ALL"} key={"allz"}>
                    All
                  </Option>
                  {this.props.gateway.map((i) => (
                    <Option value={i.id} key={i.key_name}>
                      {i.name}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item label="Message ID">
              {getFieldDecorator("smid")(<Input />)}
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item label="Vendor MessageID">
              {getFieldDecorator("gateway_smid")(<Input />)}
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item label="Status">
              {getFieldDecorator("status", {
                initialValue: "ALL",
              })(
                <Select>
                  <Option value="ALL">All</Option>
                  <Option value="S">Sent</Option>
                  <Option value="RECVD">Received</Option>
                  <Option value="FO">Fail Operator</Option>
                  <Option value="FG">Fail Gateway</Option>
                  <Option value="FM">Not Received-M</Option>
                  <Option value="A">Not-Received-A</Option>
                  <Option value="E">Expired</Option>
                  <Option value="B">Blacklist</Option>
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={4} offset={4}>
            <FormItem label=" " style={{ textAlign: "right" }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>{" "}
              <Button
                type="danger"
                htmlType="reset"
                onClick={() => {
                  this.props.form.resetFields();
                  reset();
                }}
              >
                Reset
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

const SearchRawForm = Form.create({ name: "search-raw-frm" })(SearchRawLog);

export default SearchRawForm;



// WEBPACK FOOTER //
// ./src/containers/SlRawLogs/search-form.js